import { render } from "./identification-finish.vue?vue&type=template&id=49d816d3&scoped=true&ts=true"
import script from "./identification-finish.vue?vue&type=script&lang=ts"
export * from "./identification-finish.vue?vue&type=script&lang=ts"

import "./identification-finish.vue?vue&type=style&index=0&id=49d816d3&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d816d3"]])

export default __exports__